import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  formControl: {
    width: 300,
    minWidth: '100%',
    maxWidth: '100%',

    '& ::-ms-clear': {
      display: 'none',
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginLeft: 5,
    },
  },
  reset: {
    position: 'absolute',
    right: '26px',
    fontSize: '0.8em',
    color: theme.palette.grey['600'],
    cursor: 'pointer',
    lineHeight: '32px',
  },
}));
